export default __webpack_public_path__ + "static/media/project3.90eb5bcd.png";